import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
  BrowserRouter,
  Route,
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import SnackbarProvider from "./components/snackbar/SnackbarProvider";

import App from "./App";
import { setupStore } from "./redux/store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: process.env.REACT_APP_ENVIRONMENT,
  release: process.env.REACT_APP_SENTRY_RELEASE || "3.27",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE ?? 0.1, //  Capture 10% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const store = setupStore();
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <Helmet>
        <script
          src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}`}
          async
        />
      </Helmet>

      <SnackbarProvider>
        <div className="dt-ta-tab-and-desktop-wrapper">
          <BrowserRouter>
            <SentryRoutes>
              <Route path="/*" element={<App />} />
            </SentryRoutes>
          </BrowserRouter>
        </div>
        <div className="dt-ta-mobile-coming-soon">
          <h1>
            coming soon<span className="dot">.</span>
          </h1>
          <h4>
            Training admin by DoctusTech is only available in desktop currently.
          </h4>
        </div>
      </SnackbarProvider>
    </React.StrictMode>
    <ToastContainer
      enableMultiContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
      theme="dark"
    />
    <ToastContainer
      enableMultiContainer
      containerId={"infoToast"}
      position="top-right"
      autoClose={false}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
      theme="dark"
    />
  </Provider>
);
